import { render } from "./ServicesItem.vue?vue&type=template&id=7acdf3d9"
import script from "./ServicesItem.vue?vue&type=script&lang=js"
export * from "./ServicesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__